module.exports = __webpack_public_path__ + "static/media/003-Informieren_ID_2.342d2d47.mp3";